module.exports = __webpack_public_path__ + "static/media/boss-tuagom-pic.2df4e99d.png";